import Box from '@mui/material/Box';
import { MenuItem, TextField } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import React, { useContext, useEffect, useState } from 'react';
import { ButtonOrcamento, ContainerConteudo, FiltroDate, HeaderFiltro, LinkRedirect } from './Kanban.style';
import KanbanComponent from '../../components/Kanban/KanbanComponent/Kanban.component';
import { useApi } from '../../hooks/userApi';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import ptBr from 'date-fns/locale/pt-BR';

type TUserDetailsProps = {
  id: string;
  nome: string;
  endereco: string;
  telefone: string;
  emailContato: string;
  documento: string;
  tipoDocumentoo: string;
  contato: string;
  comissao: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  permissions: [string];
  email: string;
};

type TKanbanProps = {
  user: TUserDetailsProps;
  vendedor: string;
  handleChangeVendedor: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const api = useApi();

function SelectVendedor(props: TKanbanProps) {
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);

  const [vendedores, setVendedores] = useState([props.user]);

  if (props.user.permissions.includes('Admin')) {
    useEffect(() => {
      setLoading(true);
      api
        .get('vendedor')
        .then((r) => {
          console.log('Response status:', r.status);
          console.log('Full response:', r);
          setLoading(false);
          setVendedores([{ id: 0, nome: 'Todos' }, ...r.results]);
        })
        .catch((e) => {
          const msg = `Houve um erro interno, tente mais tarde.  (${e.response.status})`;

          setLoadingMensagem(msg);
          setLoadingBtn('OK');
        });
    }, []);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'end !important',
        flexWrap: 'wrap',
        p: 1,
        m: 1,
      }}
    >
      <TextField
        select
        id="standard-select-vendedor-native"
        className="select-orcamento"
        label="Vendedor"
        value={props.vendedor}
        onChange={props.handleChangeVendedor}
        variant="outlined"
      >
        {vendedores.map((option, index) => (
          <MenuItem key={index} value={option.id}>
            {option.nome}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}

function Kanban() {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [vendedor, setVendedor] = useState(user.id || '');
  const [arrOrcamento, setOrcamento] = useState([]);
  const [validateLoad, setValidator] = useState(false);
  const [dateInicial, setDateInicial] = useState<Date | null>(null);
  const [dateFinal, setDateFinal] = useState<Date | null>(null);

  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);

  const handleChangeVendedor = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValidator(false);
    setVendedor(event.target.value);
  };

  const itemsCardsColumns = [];

  const itemEnviado = [];

  const itemFollow = [];

  const itemRecusado = [];

  const itemAprovado = [];

  const itemAtualizar = [];

  const columnBack = [
    {
      id: '1',
      title: 'Orçamentos feitos',
      items: itemsCardsColumns,
    },
    {
      id: '2',
      title: 'Orçamentos enviados',
      items: itemEnviado,
    },
    {
      id: '3',
      title: 'Follow-up',
      items: itemFollow,
    },
    {
      id: '4',
      title: 'Recusado',
      items: itemRecusado,
    },
    {
      id: '5',
      title: 'Aprovado',
      items: itemAprovado,
    },
    {
      id: '6',
      title: 'Atualizar Orçamentos',
      items: itemAtualizar,
    },
  ];

  const handleFilter = () => {
    setLoading(true);

    if (dateInicial === null || dateFinal === null) {
      setLoadingMensagem('Preencha a data inicial e final para efetuar essa filtragem.');
      setLoadingBtn('OK');
    }
    api
      .get(
        `/orcamento/data${
          vendedor == 0 ? '' : `/vendedor/${vendedor}`
        }?ini=${dateInicial?.toISOString()}&final=${dateFinal?.toISOString()}`,
      )
      .then((response) => {
        if (!response || !response.status || !response.results) {
          setLoadingMensagem('Desculpe, ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        setOrcamento(response.results || []);
        setLoading(false);
      })
      .catch((e) => {
        let msg = `Houve um erro interno, tente mais tarde.${e.message}`;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  useEffect(() => {
    setLoading(true);
    const dataAtual = new Date();
    const dataInicial = new Date(dataAtual.getTime() - 30 * 24 * 60 * 60 * 1000);
    const dataFinal = dataAtual;

    if (dataInicial !== undefined && dataFinal !== undefined) {
      console.log(vendedor);
      api
        .get(
          `/orcamento${
            vendedor === 0 ? '' : `/data/vendedor/${vendedor}`
          }?ini=${dataFinal.toISOString()}&final=${dataFinal.toISOString()}`,
        )
        .then((response) => {
          if (!response.status) {
            setLoadingMensagem('Desculpe ocorreu um erro!');
            setLoadingBtn('OK');
            return;
          }
          setOrcamento(response.results);
          setDateInicial(dataInicial);
          setDateFinal(dataFinal);
          setLoading(false);
        })
        .catch((e) => {
          let msg = `Houve um erro interno, tente mais tarde.${e.message}`;
          if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

          setLoadingMensagem(msg);
          setLoadingBtn('OK');
        });
    }
  }, [vendedor]);

  useEffect(() => {
    if (arrOrcamento && arrOrcamento.length > 0) {
      arrOrcamento.map((value) => {
        if (value.status === 'feito') {
          itemsCardsColumns.push(value);
        } else if (value.status === 'enviado') {
          itemEnviado.push(value);
        } else if (value.status === 'follow') {
          itemFollow.push(value);
        } else if (value.status === 'recusado') {
          itemRecusado.push(value);
        } else if (value.status === 'aprovado') {
          itemAprovado.push(value);
        } else if (value.status === 'atualizar') {
          itemAtualizar.push(value);
        }
      });
    }
    columnBack.map((section) => {
      if (section.items.length > 0) {
        setValidator(true);
      }
    });
  }, [arrOrcamento, validateLoad, columnBack]);

  return (
    <ContainerConteudo>
      <HeaderFiltro>
        <SelectVendedor user={user} vendedor={vendedor} handleChangeVendedor={handleChangeVendedor} />

        <FiltroDate>
          <DatePicker
            selected={dateInicial}
            dateFormat="dd/MM/yyyy"
            onChange={(newValue) => {
              setDateInicial(newValue);
            }}
            locale={ptBr}
            withPortal
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            todayButton="Hoje"
          />
          <DatePicker
            selected={dateFinal}
            dateFormat="dd/MM/yyyy"
            onChange={(newValue) => {
              setDateFinal(newValue);
            }}
            locale={ptBr}
            withPortal
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            todayButton="Hoje"
          />
          <ButtonOrcamento onClick={handleFilter}>Filtrar</ButtonOrcamento>
        </FiltroDate>
      </HeaderFiltro>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'end !important',
          flexWrap: 'wrap',
          p: 1,
          m: 1,
        }}
      >
        <LinkRedirect to="/vendedor/orcamento">+ novo orçamento</LinkRedirect>
      </Box>
      {validateLoad && <KanbanComponent dataKanban={columnBack} isView={validateLoad} />}
    </ContainerConteudo>
  );
}

export default Kanban;
